import moment from 'moment';
import { createContext, useContext, useState } from 'react';

const StateContext = createContext({
  cachedAttendances: [],
  setCachedAttendances: () => { },
  cachedDate: null,
  setCachedDate: () => {},
  cachedSearch: '',
  setCachedSearch: () => {}
});

export const AttendancesContextProvider = ({ children }) => {
  const [cachedAttendances, setCachedAttendances] = useState([]);
  const [cachedDate, setCachedDate] = useState(moment().format('YYYY-MM-DD'));
  const [cachedSearch, setCachedSearch] = useState('');

  return (
    <StateContext.Provider value={{
        cachedAttendances,
        setCachedAttendances,
        cachedDate,
        setCachedDate,
        cachedSearch,
        setCachedSearch
    }}>
        {children}
    </StateContext.Provider>
)}

export const AttendancesContext = () => useContext(StateContext);